// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"8c8b9617","97":"9a282ac9","262":"6fd62bf4","268":"406c0820","330":"3c4d14fb","392":"7d01f429","401":"e4156d0d","568":"6646f3f8","571":"b291a695","580":"4adcec06","591":"de475c84","629":"6cb8966b","697":"d916d529","737":"24e31c2e","844":"8ccf3b5c"}[chunkId] + ".js";
};